export default "__VITE_ASSET__C_T4P1qS__"